"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferTooltipLayout = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./OfferTooltipLayout.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const OfferTooltipLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['tooltip'],
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['arrow']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['cross'],
    onClick: onClose
  }, /*#__PURE__*/React.createElement(_uiKit.IconClose12, {
    color: "white_100",
    "aria-label": "closer"
  })), children);
});
exports.OfferTooltipLayout = OfferTooltipLayout;
OfferTooltipLayout.displayName = 'OfferTooltipLayout';